<template>
  <v-container fluid class="discover-agendados">
    <v-skeleton-loader
      v-if="loading"
      dark
      type="image, image, image, list-item-avatar-three-line"
      class="discover-agendados__skeleton"
    />
    <div v-else-if="error" class="discover-agendados__state discover-agendados__state--error" role="alert">
      <p>Não foi possível carregar os lançamentos agendados.</p>
      <v-btn outlined color="#7a23bd" @click="load">Tentar novamente</v-btn>
    </div>
    <div v-else-if="!months.length" class="discover-agendados__state">
      <p>Nenhum lançamento agendado nos próximos meses.</p>
    </div>
    <template v-else>
      <section v-for="(month, index) in months" :key="monthKey(month)" class="discover-agendados__month">
        <div class="discover-agendados__month-header">
          <h2 class="discover-agendados__month-title">{{ month.label }}</h2>
          <span class="discover-agendados__month-line"></span>
          <span class="discover-agendados__month-count">
            {{ month.items.length }} {{ month.items.length === 1 ? "lançamento" : "lançamentos" }}
          </span>
        </div>
        <div class="discover-agendados__carousel">
          <button
            type="button"
            class="discover-agendados__arrow discover-agendados__arrow--left"
            aria-label="Ver lançamentos anteriores"
            @click="scrollTrack(index, -1)"
          >
            <v-icon small>mdi-chevron-left</v-icon>
          </button>
          <div class="discover-agendados__track" :ref="'track-' + index">
            <ScheduledCard
              v-for="(item, itemIndex) in month.items"
              :key="itemIndex"
              :item="item"
            />
          </div>
          <button
            type="button"
            class="discover-agendados__arrow discover-agendados__arrow--right"
            aria-label="Ver próximos lançamentos"
            @click="scrollTrack(index, 1)"
          >
            <v-icon small>mdi-chevron-right</v-icon>
          </button>
        </div>
      </section>
    </template>
  </v-container>
</template>

<script>
import ScheduledCard from "@/components/cards/ScheduledCard.vue";
import { getScheduledUpcoming } from "@/server/workService";

export default {
  name: "DiscoverAgendados",
  components: {
    ScheduledCard,
  },
  data() {
    return {
      months: [],
      loading: true,
      error: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = false;
      try {
        const data = await getScheduledUpcoming();
        this.months = data?.data?.months || data?.months || [];
      } catch (error) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    monthKey(month) {
      return `${month.year}-${month.month}`;
    },
    scrollTrack(index, direction) {
      const ref = this.$refs[`track-${index}`];
      const track = Array.isArray(ref) ? ref[0] : ref;
      if (!track) return;
      track.scrollBy({
        left: direction * Math.round(track.clientWidth * 0.8),
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.discover-agendados {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4px 0;
  color: #fff;
}

.discover-agendados__skeleton {
  max-width: 1200px;
  background: transparent;
}

.discover-agendados__state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 16px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

.discover-agendados__state p {
  margin: 0;
}

.discover-agendados__state--error p {
  color: #f25568;
}

.discover-agendados__month {
  margin-bottom: 32px;
}

.discover-agendados__month-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.discover-agendados__month-title {
  margin: 0;
  color: #fff;
  font-size: 20px;
  font-weight: 800;
  text-transform: uppercase;
  white-space: nowrap;
}

.discover-agendados__month-line {
  flex: 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.14);
}

.discover-agendados__month-count {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.discover-agendados__carousel {
  position: relative;
  display: flex;
  align-items: center;
}

.discover-agendados__track {
  display: flex;
  gap: 14px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 6px 2px 10px;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.discover-agendados__track::-webkit-scrollbar {
  display: none;
}

.discover-agendados__arrow {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  z-index: 2;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(18, 13, 24, 0.92);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.discover-agendados__arrow:hover {
  background: rgb(78, 0, 141);
}

.discover-agendados__arrow--left {
  left: -4px;
}

.discover-agendados__arrow--right {
  right: -4px;
}

@media (max-width: 768px) {
  .discover-agendados__arrow {
    display: none;
  }
}
</style>